export default function Footer() {
  return (
    <footer className="bg-foreground-900">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-20">
        {/* Upper Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Left - Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-xl bg-accent-500/20 flex items-center justify-center">
                <span className="font-heading text-accent-400 font-bold text-lg">JM</span>
              </div>
              <span className="font-heading text-2xl font-bold text-background-50 tracking-tight">
                Job Manifest
              </span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed mb-8 max-w-sm">
              A specialist recruitment consulting firm built on one belief: the right people in the right places change everything. Est. 2017.
            </p>
          </div>

          {/* Middle - Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-background-50/60 text-xs font-semibold tracking-widest uppercase mb-6">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3">
              {[
                { label: 'About Us', href: '/#about' },
                { label: 'Industries', href: '/industries' },
                { label: 'Services', href: '/services' },
                { label: 'Why Choose Us', href: '/why-us' },
                { label: 'Our Team', href: '/team' },
                { label: 'Our Clients', href: '/#clients' },
                { label: 'Apply Now', href: '/#apply' },
                { label: 'Contact', href: '/#contact' },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-foreground-300 text-sm hover:text-accent-400 transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Right - Contact */}
          <div className="md:col-span-4">
            <h4 className="text-background-50/60 text-xs font-semibold tracking-widest uppercase mb-6">
              Get in Touch
            </h4>
            <div className="space-y-4 mb-8">
              <a
                href="tel:+918447691414"
                className="flex items-center gap-2 text-foreground-300 text-sm hover:text-accent-400 transition-colors"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-accent-400 text-xs"></i>
                </span>
                8447691414
              </a>
              <a
                href="tel:+919799374635"
                className="flex items-center gap-2 text-foreground-300 text-sm hover:text-accent-400 transition-colors"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-accent-400 text-xs"></i>
                </span>
                9799374635
              </a>
              <a
                href="mailto:info@jobmanifest.in"
                className="flex items-center gap-2 text-foreground-300 text-sm hover:text-primary-300 transition-colors"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-400 text-xs"></i>
                </span>
                info@jobmanifest.in
              </a>
            </div>

            <h4 className="text-background-50/60 text-xs font-semibold tracking-widest uppercase mb-3">
              Visit Us
            </h4>
            <p className="text-foreground-400 text-sm leading-relaxed">
              B-37, Sector 63<br />
              Noida - 201301
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 md:mt-20 pt-8 border-t border-foreground-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-6">
              {[
                { icon: 'ri-linkedin-fill', href: 'https://www.linkedin.com/company/jobmanifest/' },
                { icon: 'ri-instagram-line', href: 'https://www.instagram.com/jobmanifesthr?igsh=MW1lMXZ3cWtocXBvYg==' },
                { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/share/18stBpr1kq/?mibextid=wwXIfr' },
              ].map((social) => (
                <a
                  key={social.icon}
                  href={social.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-foreground-400 text-lg hover:text-accent-400 transition-colors"
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>

            <p className="text-foreground-500 text-xs text-center">
              &copy; {new Date().getFullYear()} Job Manifest Recruitment Consulting. All rights reserved.
            </p>

            <div className="flex items-center gap-6">
              <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}